import GQL_BENCHMARK_REPORT_DATA from './benchmarkReportQuery';
import reportingGraphqlRequest from '../reportingGraphqlRequest';
// Import with explicit 'any' type to avoid TypeScript errors
import StudentRecordService from '../StudentRecordService';


export interface GetLatestAssessmentsParams {
  studentIds: string[];
  dateRange?: dateRange;
  periodId?: number;
  screeningWindow?: string;
  testType?: string;
  equatedScores?: boolean;
  locale?: string;
}

interface dateRange {
  dateStart: Date;
  dateEnd: Date;
}

export const fetchBenchmarkReportData = async (
  {
    studentIds,
    equatedScores = false,
    locale = 'EN_US',
    dateRange,
    periodId,
    screeningWindow,
    testType
  }: GetLatestAssessmentsParams,
) => {
  locale = locale.replace(/-/g, '_');
  try {
    const { dateStart, dateEnd } = dateRange || {};
    
    console.log("🚀 Benchmark Report API Call:", {
      studentIds: studentIds.length,
      equatedScores,
      locale,
      dateStart,
      dateEnd,
      periodId,
      screeningWindow,
      testType
    });
    
    const response = await StudentRecordService.getLatestAssessments({
      studentIds,
      equatedScores,
      locale,
      dateStart: dateStart || undefined,
      dateEnd: dateEnd || undefined,
      periodId,
      screeningWindow,
      testType,
    });
    return response;
  } catch (error) {
    console.error('Error fetching benchmark report data', error);
  }
};

export interface GetScaledCutlinesParams {
  districtId: number;
  schoolId: number;
  grade: number;
  scale: string;
  periodId: number[];
}

/**
 * Fetches scaled cutlines for the benchmark report
 * @param params - Parameters for the scaled cutlines query
 * @returns The cutlines data with district, national, and spanish standards
 */
export const fetchScaledCutlines = async ({
  districtId,
  schoolId,
  grade,
  scale,
  periodId
}: GetScaledCutlinesParams) => {
  try {
    // Cast StudentRecordService to any to avoid TypeScript errors
    const service = StudentRecordService as any;
    const response = await service.getScaledCutlines({
      districtId, 
      schoolId, 
      grade, 
      scale, 
      periodId
    });
    return response;
  } catch (error) {
    console.error("Error fetching scaled cutlines data:", error);
    throw error;
  }
};